"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppVersion = void 0;
var getAppVersion = function () {
    var version = process.env.ARTIFACT_VERSION;
    return version.replace('-SNAPSHOT', '');
};
exports.getAppVersion = getAppVersion;
//# sourceMappingURL=appVersion.js.map